import packageJson from '../../package.json';

export const environment = {
  env: 'sandbox',
  api: 'https://sandbox-api.tilled.com',
  iron: 'https://sandbox-app.tilled.com',
  hawkeye: 'https://sandbox-app.tilled.com',
  sentryDSN:
    'https://4b2d9b3fd64b4f258ffa338557deb906@o377738.ingest.sentry.io/5865083',
  production: true,
  hmr: false,
  whiteLabelDomain: '.sandbox-paymentsonline.io',
  sandboxWhiteLabelDomain: '.sandbox-paymentsonline.io',
  // Same okta values for all environments
  okta: {
    issuer: 'https://tilled.okta.com/oauth2/default',
    client_id: '0oa3ecwce9EbZKTEy5d7',
  },
  version: packageJson.version,
};
